import React from "react";
import { useTranslation } from "react-i18next";

// Component created cause was needed to be implemented after whole component was developed

const Selector = ({ selector, handleSelectedRange }) => {
  const { text, value, active } = selector;
  return (
    <button
      data-button-type={active ? "primary" : "secondary"}
      onClick={() => handleSelectedRange(value)}
    >
      {text}
    </button>
  );
};

// The component works based on weeks number. Since whe have weeks or months options, we can use weeks as a base
// We split it by 4 to get months
export const IndependentDateRangeComponent = ({
  weeksSelected,
  handleSelectedRange,
  classNames,
}) => {
  const { t } = useTranslation("athlete-portal");
  const selectors = [
    {
      key: "2weeks",
      text: t("reports.rangeSelector.twoWeeks"),
      value: 2,
      active: weeksSelected === 2,
    },
    {
      key: "1month",
      text: t("reports.rangeSelector.oneMonth"),
      value: 4,
      active: weeksSelected === 4,
    },
    {
      key: "3month",
      text: t("reports.rangeSelector.threeMonths"),
      value: 12,
      active: weeksSelected === 12,
    },
    {
      key: "6month",
      text: t("reports.rangeSelector.sixMonths"),
      value: 24,
      active: weeksSelected === 24,
    },
    {
      key: "lifetime",
      text: t("reports.rangeSelector.lifetime"),
      value: 0,
      active: weeksSelected === 0,
    },
  ];

  return (
    <div className={`selector-container ${classNames}`}>
      {selectors.map((selector, idx) => (
        <Selector
          key={`range-selector-${idx}`}
          selector={selector}
          handleSelectedRange={handleSelectedRange}
        />
      ))}
    </div>
  );
};
